import LanguageDetector from 'i18next-browser-languagedetector';

export const languageDetector = new LanguageDetector(null, {
  order: [
    'sessionStorage',
    'navigator',
    'querystring',
    'cookie',
    'localStorage',
    'htmlTag',
  ],
  lookupSessionStorage: 'i18nextLng',
});
